import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

export interface AutopilotLimits {
  maxChannels: number
  maxPostsPerChannel: number
  disabledChannels: string[]
}

type Props = {
  forcePlan?: PaymentPlanKey
}

export const FREE_REFERRAL_TIERS = [0, 1, 3, 6, 10]
export const FREE_REWARD_TIERS = [1, 2, 3, 4, 5]

const calculateFreeRewardAmount = (count: number): number => {
  if (count >= 10) return FREE_REWARD_TIERS[4]
  if (count >= 6) return FREE_REWARD_TIERS[3]
  if (count >= 3) return FREE_REWARD_TIERS[2]
  if (count >= 1) return FREE_REWARD_TIERS[1]
  return FREE_REWARD_TIERS[0]
}

export const useAutopilotLimits = (props?: Props): AutopilotLimits => {
  const { forcePlan } = props || {}

  const workspace = useCurrentWorkspace()
  const tierUsageStore = useRootStore().tierUsageStore
  const { currentSubscription } = tierUsageStore

  const isOnStarterPlan = currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotStarter
  const isOnGrowthPlan = currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotGrowth

  if ((!forcePlan && workspace?.is_ap_freemium) || forcePlan === PaymentPlanKey.Free) {
    const rewardAmount = calculateFreeRewardAmount(workspace?.referral_rewards?.free || 0)

    return {
      maxChannels: 3,
      maxPostsPerChannel: rewardAmount,
      disabledChannels: ['crosspost_contents', 'video_crosspost_contents'],
    }
  }

  if ((!forcePlan && isOnStarterPlan) || forcePlan === PaymentPlanKey.BlazeAutopilotStarter) {
    return {
      maxChannels: 3,
      maxPostsPerChannel: Infinity,
      disabledChannels: [],
    }
  }

  if ((!forcePlan && isOnGrowthPlan) || forcePlan === PaymentPlanKey.BlazeAutopilotGrowth) {
    return {
      maxChannels: 10,
      maxPostsPerChannel: Infinity,
      disabledChannels: [],
    }
  }

  return {
    maxChannels: Infinity,
    maxPostsPerChannel: Infinity,
    disabledChannels: [],
  }
}
